// GENERATED by scripts/gen-look.py from workspace-api-schemas-2026-10-02.json (GET https://workspaces.nanome.ai/schemas, AllowAnonymous)
// Do not edit by hand. The app also fetches /schemas at startup and overlays these.

export const VISUALIZATION_PRESETS = {
  "ballAndStick": {
    "kind": "Atomistic",
    "visible": true,
    "size": {
      "sizeOption": "Physical",
      "scale": 0.25
    },
    "coloring": {
      "kind": "Property",
      "carbonsOnly": true,
      "colors": [
        "CBAAFF",
        "FF9800",
        "00FDF1",
        "FF8CFF",
        "FFC200",
        "00EBFF",
        "FF78DA",
        "ABE600",
        "42CCFF",
        "FF7971",
        "00FB87"
      ],
      "propertySource": "ChainInstance",
      "paletteType": "Default"
    },
    "renderAtom": "All",
    "renderBond": true,
    "bondScale": 0.2,
    "renderHydrogen": "All"
  },
  "stick": {
    "kind": "Atomistic",
    "visible": true,
    "size": {
      "sizeOption": "Uniform",
      "scale": 0.2
    },
    "coloring": {
      "kind": "Property",
      "carbonsOnly": true,
      "colors": [
        "CBAAFF",
        "FF9800",
        "00FDF1",
        "FF8CFF",
        "FFC200",
        "00EBFF",
        "FF78DA",
        "ABE600",
        "42CCFF",
        "FF7971",
        "00FB87"
      ],
      "propertySource": "ChainInstance",
      "paletteType": "Default"
    },
    "renderAtom": "All",
    "renderBond": true,
    "bondScale": 0.2,
    "renderHydrogen": "All"
  },
  "wire": {
    "kind": "Atomistic",
    "visible": true,
    "size": {
      "sizeOption": "Uniform",
      "scale": 0.1
    },
    "coloring": {
      "kind": "Property",
      "carbonsOnly": true,
      "colors": [
        "CBAAFF",
        "FF9800",
        "00FDF1",
        "FF8CFF",
        "FFC200",
        "00EBFF",
        "FF78DA",
        "ABE600",
        "42CCFF",
        "FF7971",
        "00FB87"
      ],
      "propertySource": "ChainInstance",
      "paletteType": "Default"
    },
    "renderAtom": "NonBondedOnly",
    "renderBond": true,
    "bondScale": 0.05,
    "renderHydrogen": "All"
  },
  "spacefill": {
    "kind": "Atomistic",
    "visible": true,
    "size": {
      "sizeOption": "Physical",
      "scale": 1
    },
    "coloring": {
      "kind": "Property",
      "carbonsOnly": true,
      "colors": [
        "CBAAFF",
        "FF9800",
        "00FDF1",
        "FF8CFF",
        "FFC200",
        "00EBFF",
        "FF78DA",
        "ABE600",
        "42CCFF",
        "FF7971",
        "00FB87"
      ],
      "propertySource": "ChainInstance",
      "paletteType": "Default"
    },
    "renderAtom": "All",
    "renderBond": false,
    "bondScale": 0,
    "renderHydrogen": "All"
  },
  "focus": {
    "kind": "Atomistic",
    "visible": true,
    "size": {
      "sizeOption": "Uniform",
      "scale": 0.6
    },
    "coloring": {
      "kind": "Property",
      "carbonsOnly": true,
      "colors": [
        "CBAAFF",
        "FF9800",
        "00FDF1",
        "FF8CFF",
        "FFC200",
        "00EBFF",
        "FF78DA",
        "ABE600",
        "42CCFF",
        "FF7971",
        "00FB87"
      ],
      "propertySource": "ChainInstance",
      "paletteType": "Default"
    },
    "renderAtom": "All",
    "renderBond": true,
    "bondScale": 0.3,
    "renderHydrogen": "All"
  },
  "cartoon": {
    "kind": "Ribbon",
    "visible": true,
    "size": {
      "sizeOption": "NoSize",
      "scale": 0
    },
    "coloring": {
      "kind": "Property",
      "carbonsOnly": false,
      "colors": [
        "CBAAFF",
        "FF9800",
        "00FDF1",
        "FF8CFF",
        "FFC200",
        "00EBFF",
        "FF78DA",
        "ABE600",
        "42CCFF",
        "FF7971",
        "00FB87"
      ],
      "propertySource": "ChainInstance",
      "paletteType": "Default"
    },
    "ribbonStyle": "Cartoon"
  },
  "coil": {
    "kind": "Ribbon",
    "visible": true,
    "size": {
      "sizeOption": "NoSize",
      "scale": 0
    },
    "coloring": {
      "kind": "Property",
      "carbonsOnly": false,
      "colors": [
        "CBAAFF",
        "FF9800",
        "00FDF1",
        "FF8CFF",
        "FFC200",
        "00EBFF",
        "FF78DA",
        "ABE600",
        "42CCFF",
        "FF7971",
        "00FB87"
      ],
      "propertySource": "ChainInstance",
      "paletteType": "Default"
    },
    "ribbonStyle": "Coil"
  },
  "surface": {
    "kind": "MolecularSurface",
    "visible": true,
    "size": {
      "sizeOption": "NoSize",
      "scale": 0
    },
    "coloring": {
      "kind": "Property",
      "carbonsOnly": false,
      "colors": [
        "CBAAFF",
        "FF9800",
        "00FDF1",
        "FF8CFF",
        "FFC200",
        "00EBFF",
        "FF78DA",
        "ABE600",
        "42CCFF",
        "FF7971",
        "00FB87"
      ],
      "propertySource": "ChainInstance",
      "paletteType": "Default"
    },
    "opacity": 0.5,
    "subsurface": false,
    "wireframe": false
  },
  "surfaceSubsurface": {
    "kind": "MolecularSurface",
    "visible": true,
    "size": {
      "sizeOption": "NoSize",
      "scale": 0
    },
    "coloring": {
      "kind": "Property",
      "carbonsOnly": false,
      "colors": [
        "CBAAFF",
        "FF9800",
        "00FDF1",
        "FF8CFF",
        "FFC200",
        "00EBFF",
        "FF78DA",
        "ABE600",
        "42CCFF",
        "FF7971",
        "00FB87"
      ],
      "propertySource": "ChainInstance",
      "paletteType": "Default"
    },
    "opacity": 0.5,
    "subsurface": true,
    "wireframe": false
  },
  "residueLabel": {
    "kind": "ResidueLabel",
    "visible": true,
    "size": {
      "sizeOption": "NoSize",
      "scale": 0
    },
    "coloring": {
      "kind": "Uniform",
      "carbonsOnly": false,
      "uniformColor": "FFFFFF"
    }
  },
  "interactionHydrogenBond": {
    "kind": "Interaction",
    "visible": true,
    "size": {
      "sizeOption": "Uniform",
      "scale": 0.05
    },
    "coloring": {
      "kind": "Uniform",
      "carbonsOnly": false,
      "uniformColor": "FFFF00"
    },
    "bondScale": 0.2,
    "gapScale": 0.2,
    "interactionType": "HydrogenBonds",
    "ligandToPocketOnly": false
  },
  "interactionHydrogenBondPolymer": {
    "kind": "Interaction",
    "visible": true,
    "size": {
      "sizeOption": "Uniform",
      "scale": 0.05
    },
    "coloring": {
      "kind": "Uniform",
      "carbonsOnly": false,
      "uniformColor": "FFFF00"
    },
    "bondScale": 0.2,
    "gapScale": 0.2,
    "interactionType": "HydrogenBondsPolymerPolymer",
    "ligandToPocketOnly": false
  },
  "interactionClash": {
    "kind": "Interaction",
    "visible": true,
    "size": {
      "sizeOption": "Uniform",
      "scale": 0.5
    },
    "coloring": {
      "kind": "Uniform",
      "carbonsOnly": false,
      "uniformColor": "CC003D"
    },
    "bondScale": 0.05,
    "gapScale": 0,
    "interactionType": "Clash",
    "ligandToPocketOnly": false
  },
  "interactionSaltBridge": {
    "kind": "Interaction",
    "visible": true,
    "size": {
      "sizeOption": "Uniform",
      "scale": 0.06
    },
    "coloring": {
      "kind": "Uniform",
      "carbonsOnly": false,
      "uniformColor": "FF6600"
    },
    "bondScale": 0.3,
    "gapScale": 0.15,
    "interactionType": "SaltBridges",
    "ligandToPocketOnly": false
  },
  "interactionPiStacking": {
    "kind": "Interaction",
    "visible": true,
    "size": {
      "sizeOption": "Uniform",
      "scale": 0.04
    },
    "coloring": {
      "kind": "Uniform",
      "carbonsOnly": false,
      "uniformColor": "6443FF"
    },
    "bondScale": 0.25,
    "gapScale": 0.35,
    "interactionType": "PiStacking",
    "ligandToPocketOnly": false
  },
  "interactionCationPi": {
    "kind": "Interaction",
    "visible": true,
    "size": {
      "sizeOption": "Uniform",
      "scale": 0.06
    },
    "coloring": {
      "kind": "Uniform",
      "carbonsOnly": false,
      "uniformColor": "0080FF"
    },
    "bondScale": 0.2,
    "gapScale": 0.2,
    "interactionType": "PiCation",
    "ligandToPocketOnly": false
  },
  "interactionHalogen": {
    "kind": "Interaction",
    "visible": true,
    "size": {
      "sizeOption": "Uniform",
      "scale": 0.05
    },
    "coloring": {
      "kind": "Uniform",
      "carbonsOnly": false,
      "uniformColor": "3AE2AA"
    },
    "bondScale": 0.15,
    "gapScale": 0.25,
    "interactionType": "Halogen",
    "ligandToPocketOnly": false
  },
  "interactionHydrophobic": {
    "kind": "Interaction",
    "visible": true,
    "size": {
      "sizeOption": "Uniform",
      "scale": 0.03
    },
    "coloring": {
      "kind": "Uniform",
      "carbonsOnly": false,
      "uniformColor": "808080"
    },
    "bondScale": 0.12,
    "gapScale": 0.3,
    "interactionType": "Hydrophobic",
    "ligandToPocketOnly": false
  },
  "interactionMetalCoordination": {
    "kind": "Interaction",
    "visible": true,
    "size": {
      "sizeOption": "Uniform",
      "scale": 0.075
    },
    "coloring": {
      "kind": "Uniform",
      "carbonsOnly": false,
      "uniformColor": "A020F0"
    },
    "bondScale": 0.35,
    "gapScale": 0.25,
    "interactionType": "MetalCoordination",
    "ligandToPocketOnly": false
  },
  "interactionHalogenPi": {
    "kind": "Interaction",
    "visible": true,
    "size": {
      "sizeOption": "Uniform",
      "scale": 0.05
    },
    "coloring": {
      "kind": "Uniform",
      "carbonsOnly": false,
      "uniformColor": "00CED1"
    },
    "bondScale": 0.2,
    "gapScale": 0.2,
    "interactionType": "HalogenPi",
    "ligandToPocketOnly": false
  }
} as const;

export const COLORING_PRESETS = {
  "elementType": {
    "kind": "ElementType",
    "carbonsOnly": false
  },
  "chainInstance": {
    "kind": "Property",
    "carbonsOnly": false,
    "colors": [
      "CBAAFF",
      "FF9800",
      "00FDF1",
      "FF8CFF",
      "FFC200",
      "00EBFF",
      "FF78DA",
      "ABE600",
      "42CCFF",
      "FF7971",
      "00FB87"
    ],
    "propertySource": "ChainInstance",
    "paletteType": "Default"
  },
  "chainName": {
    "kind": "Property",
    "carbonsOnly": false,
    "colors": [
      "E69F00",
      "56B4E9",
      "CC79A7",
      "E69F00",
      "9933FF",
      "009E73",
      "CC0033",
      "F0E442",
      "3366FF",
      "D55E00",
      "999933",
      "0072B2",
      "660066",
      "FFCC00",
      "FF6666",
      "66CC99",
      "339999",
      "FF9900",
      "33CC33",
      "FF0033",
      "0066CC",
      "99CC00",
      "FF6699",
      "6600CC",
      "33CCCC",
      "FF3300",
      "66FF66",
      "FF99CC",
      "66FFFF",
      "FFCC66"
    ],
    "propertySource": "ChainName",
    "paletteType": "Default"
  },
  "modelInstance": {
    "kind": "Property",
    "carbonsOnly": false,
    "colors": [
      "CBAAFF",
      "FF9800",
      "00FDF1",
      "FF8CFF",
      "FFC200",
      "00EBFF",
      "FF78DA",
      "ABE600",
      "42CCFF",
      "FF7971",
      "00FB87"
    ],
    "propertySource": "ModelInstance",
    "paletteType": "Default"
  },
  "residueType": {
    "kind": "ResidueType",
    "carbonsOnly": false
  },
  "secondaryStructure": {
    "kind": "SecondaryStructure",
    "carbonsOnly": false
  },
  "bFactorColdToWarm": {
    "kind": "Property",
    "carbonsOnly": false,
    "colors": [
      "0000FF",
      "7F7FFF",
      "FFFFFF",
      "FF7F7F",
      "FF0000"
    ],
    "propertySource": "BFactor",
    "paletteType": "Interpolated"
  },
  "atomSerialRainbow": {
    "kind": "Property",
    "carbonsOnly": false,
    "colors": [
      "8F00FF",
      "4B0082",
      "0000FF",
      "00FF00",
      "FFFF00",
      "FF7F00",
      "FF0000"
    ],
    "propertySource": "AtomSerial",
    "paletteType": "Interpolated"
  },
  "occupancy": {
    "kind": "Property",
    "carbonsOnly": false,
    "colors": [
      "0000FF",
      "7F7FFF",
      "FFFFFF",
      "FF7F7F",
      "FF0000"
    ],
    "propertySource": "Occupancy",
    "paletteType": "Default"
  },
  "hydrogenBonding": {
    "kind": "HydrogenBonding",
    "carbonsOnly": false
  },
  "uniformWhite": {
    "kind": "Uniform",
    "carbonsOnly": false,
    "uniformColor": "FFFFFF"
  },
  "electrostatic": {
    "kind": "Electrostatic",
    "carbonsOnly": false,
    "rampMin": -5,
    "rampMax": 5
  }
} as const;

export type VisualizationPresetName = keyof typeof VISUALIZATION_PRESETS;
export type ColoringPresetName = keyof typeof COLORING_PRESETS;
